;
(function ($) {
  var dataKey = 'app.modals';
  var Modals = function Modals(element, options) {
    this.element = element;
    this.options = {
      key: this.element.attr(this.attr.id),
      type: this.element.attr(this.attr.modal),
      showCloseBtn: false
    }, this.init(options);
  };
  Modals.prototype = {
    validModalTypes: ['ajax'],
    attr: {
      id: 'data-modal-id',
      modal: 'data-modal'
    },
    callbacks: {
      callbacks: {
        open: function open() {
          var _this = this;
          $.magnificPopup.instance.wrap[0].addEventListener('focus', function () {
            app.initElementListeners($('.modal'));
            $('.mfp-content').attr('id', _this.st.key);
            $('[data-modal-close]').on('click', function () {
              $.magnificPopup.close();
            });
          });
        },
        close: function close() {
          var spinner = $('.form-spinner');
          if (spinner.length) {
            spinner.hide();
          }
        }
      }
    },
    /**
     * Initialise Modal
     * Initialises the magnificPopup plugin or fails depending on the outcome of the modal type validation.
     * @public
     * @constructor
     * @param {string} options - Apply and extend options into init if needed.
     */

    init: function init(options) {
      $.extend(this.options, options);
      if (this._validateModalType(this.element)) {
        this.element.magnificPopup($.extend(true, {}, this.options, this.callbacks));
      } else {
        console.log('An invalid modal type was provided.');
      }
    },
    /**
     * Validate Modal Type
     * Returns the outcome of the validation
     * @private
     * @param {string} $elm - The element which triggered the plugin.
     */

    _validateModalType: function _validateModalType($elm) {
      var type = this._getModalType($elm);
      return $.inArray(type, this.validModalTypes) === -1 ? false : true;
    },
    /**
     * Get Modal Type
     * Returns the modal type passed when initialising the plugin.
     * @private
     * @param {string} $elm - The element which triggered the plugin.
     */

    _getModalType: function _getModalType($elm) {
      return $elm.attr(this.attr.modal);
    }
  };

  /**
   * Global callback function which by default all [data-modal] triggers this plugin.
   * @method $.fn.app_modals()
   * @public
   * @constructor
   * @param {string} options
   * @optional options
   * @example $(element).app_modals();
   */

  $.fn.app_modals = function (options) {
    var plugin = this.data(dataKey);
    if (plugin instanceof Modals) {
      if (typeof options !== 'undefined') {
        plugin.init(options);
      }
    } else {
      plugin = new Modals(this, options);
      this.data(dataKey, plugin);
    }
    return plugin;
  };
})(jQuery, window, document);